import React from 'react';
import { connect } from 'react-redux';
import { selectIsWindowMode } from '@ff-os/pdp-shared-redux/slices/globalSlice';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { PrefabPickerAccordion } from './partials/PrefabPickerAccordion';
import { PrefabPickerGrid } from './partials/PrefabPickerGrid';

const _PrefabPicker = ({ runsInWindow }: Props) => {

    const isMobile = useMobile();

    if (isMobile || runsInWindow) {
        return <PrefabPickerGrid isMobile={isMobile} />;
    } else {
        return <PrefabPickerAccordion />;
    }
};

type Props = {
    runsInWindow: boolean;
};

const mapStateToProps = (state: GiftPdpState) => ({
    runsInWindow: selectIsWindowMode(state)
});

export const PrefabPicker = connect(mapStateToProps)(_PrefabPicker);